const WHITELIST_KEYS = {
    Escape: 1, Enter: 1,
    KeyS: 1, KeyW: 1, KeyD: 1, KeyA: 1,
    Space: 1,
    ArrowUp: 1, ArrowDown: 1, ArrowLeft: 1, ArrowRight: 1
};

const BLACKLISTED_TAGS = [ 'TEXTAREA', 'SELECT', 'INPUT' ]
    .reduce((p, v) => (p[v] = true, p), {});


export default class KbdController {
    constructor() {
        this.keys = Object.keys(WHITELIST_KEYS).reduce((p, v) => (p[v] = false, p), {});
        this.keysFired = Object.keys(WHITELIST_KEYS).reduce((p, v) => (p[v] = false, p), {});
        this.pressedCount = 0;
        this._isListening = false;
        this._frame = 0;
        this._pressedFrame = null;

        this._onKeyDown = this._onKeyDown.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this.unpressAllKeys = this.unpressAllKeys.bind(this);

        this.unpressAllKeys();
        this.pressedCount = 0;
    }


    listen() {
        if (this._isListening) return;
        this._isListening = true;
        window.addEventListener('keydown', this._onKeyDown, { passive: false });
        window.addEventListener('keyup', this._onKeyUp);
        window.addEventListener('mousedown', this.unpressAllKeys, { passive: true });
        window.addEventListener('blur', this.unpressAllKeys);
        window.addEventListener('contextmenu', this.unpressAllKeys);
    }


    poll() {
        if (this._pressedFrame !== null && this._frame >= this._pressedFrame + 1) {
            this._pressedFrame = null;
            this._unpressPreviousKeys();
        }
        this._frame++;
    }


    unpressAllKeys() {
        for (const k in this.keys) this._unpressKey(k);
    }


    _onKeyDown(e) {
        if (!WHITELIST_KEYS[e.code]) return;
        const active = document.activeElement;
        if (active && BLACKLISTED_TAGS[active.tagName]) return;
        e.preventDefault();
        this._pressKey(e.code);
    }


    _onKeyUp(e) {
        if (!WHITELIST_KEYS[e.code]) return;
        this._unpressKey(e.code);
    }


    _pressKey(code) {
        if (this.keys[code]) return;
        this.keys[code] = true;
        this.keysFired[code] = true;
        this.pressedCount++;
        this._pressedFrame = this._frame;
    }


    _unpressKey(code) {
        if (!this.keys[code]) return;
        this.keys[code] = false;
        this.pressedCount = Math.max(this.pressedCount - 1, 0);
    }


    _unpressPreviousKeys() {
        for (const k in this.keysFired) this.keysFired[k] = false;
    }
}
